export const validateCorteQuantities = ({ cantidad1, cantidad2 }) => {
  const c1 = Number(cantidad1) || 0;
  const c2 = Number(cantidad2) || 0;

  if (c1 <= 0) {
    return { valid: false, message: "La cantidad de Corte 1 debe ser mayor a 0." };
  }
  if (c2 < 0) {
    return { valid: false, message: "La cantidad de Corte 2 no puede ser negativa." };
  }
  return { valid: true, message: "" };
};

export const computeCorteEstado = ({ completado }) =>
  completado ? "Listo" : "En Curso";

export const computeCorteTotal = ({ cantidad1, cantidad2 }) =>
  (Number(cantidad1) || 0) + (Number(cantidad2) || 0);

// El checkbox "Completado" siempre manda para decidir estadoNuevo (via computeCorteEstado).
// Esta función solo decide si ese cambio amerita crear un nuevo registro de Costura:
// únicamente en la transición hacia "Listo" que no estaba ya en "Listo" antes de este guardado.
export const shouldCreateCostura = ({ estadoPrevio, estadoNuevo }) =>
  estadoPrevio !== "Listo" && estadoNuevo === "Listo";
